import type { IHubSpotData } from '../../types';

// sandbox and production data
export const demoFormData: IHubSpotData[] = [
  //ENGLISH MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
    'name': ' Main Demo Form - English (EN)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Submit',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'First name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Last name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Email Address',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Phone number',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Company Website',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Number of contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1K',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 3K',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 25K',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 100K',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 500K',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M+',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Tell me more. Sign me up for marketing communications from Klaviyo.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741162807129,
    'updatedAt': 1742483599839,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'lang',
        'value': 'en',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4732591,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742483599839,
    'businessUnitId': 0,
    'portableKey': 'c1da9580-9d03-4616-96a8-b193b37ca03e',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // FRENCH MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': 'bc51f195-7772-4a17-b5b8-8f152c063914',
    'name': 'Main Demo Form - French (FR)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Soumettre',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Prénom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Adresse e-mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numéro de téléphone',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Site web de l’entreprise',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Nombre de contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1&nbsp;000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1&nbsp;000 - 3&nbsp;000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3&nbsp;000 - 25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000 - 100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000 - 500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000 - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M et +',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Je veux en savoir plus. Je souhaite m’inscrire pour recevoir des communications marketing de Klaviyo.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'Source UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'Support UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'Contenu UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'Campagne UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'Terme UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741163395005,
    'updatedAt': 1742485606431,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'fr',
      },
      {
        'name': 'clonedFromForm',
        'value': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4732591,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742485606431,
    'businessUnitId': 0,
    'portableKey': '8368b887-ad11-4a2a-946a-7ba9137c72d0',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // GERMAN MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': 'cb4baa41-95c1-4cfd-9e7b-417d19a0bea2',
    'name': 'Main Demo Form - German (DE)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Senden',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Vorname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nachname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-Mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Telefonnummer',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Website des Unternehmens',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Anzahl der Kontakte',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0-1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000-3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000-25.0000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000–500.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000-500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000–1&nbsp;Mio.',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '+1&nbsp;Mio.',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Ich würde gern mehr erfahren und möchte Marketing-Nachrichten von Klaviyo erhalten.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM-Quelle',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM-Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM-Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM-Kampagne',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM-Keyword',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'most_recent_lead_source_detail',
            'label': 'Most Recent Lead Source Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741163606041,
    'updatedAt': 1742485507720,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'de',
      },
      {
        'name': 'clonedFromForm',
        'value': 'bc51f195-7772-4a17-b5b8-8f152c063914',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4732591,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742485507720,
    'businessUnitId': 0,
    'portableKey': '18b9cca8-3ed5-4ef4-8bfa-46a1edab9873',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // ITALIAN MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': '325369ac-8d5a-48f3-9a6b-4e98ca8168a3',
    'name': 'Main Demo Form - Italian (IT)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Invia',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Cognome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-Mail&#xa0;',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numero di telefono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sito web dell\'azienda',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Numero di contatti',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000 - 3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000 - 25.000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25.000 - 100.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000 - 500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000 - 1.000.000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Oltre 1.000.000',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Voglio saperne di più e iscrivermi alle comunicazioni di marketing di Klaviyo.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'Mezzo UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'Fonte UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'Contenuto UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'Campagna UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'Termine UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741163653409,
    'updatedAt': 1742485276821,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'it',
      },
      {
        'name': 'clonedFromForm',
        'value': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4732591,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742485276821,
    'businessUnitId': 0,
    'portableKey': '7d741c5d-5aaf-4cf0-91b7-7412a47235f6',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // SPANISH MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': '0158aa5c-8f1f-4d6c-b4c4-679e16f909c9',
    'name': ' Main Demo Form - Spanish (ES)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Enviar',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nombre',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Apellidos',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Correo electrónico',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Número de teléfono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sitio web de la empresa',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Número de contactos',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1000-3000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3000-25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000-100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000-500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000-1&nbsp;000&nbsp;000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Más de un millón',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Quiero saber más y suscribirme a las comunicaciones de marketing de Klaviyo.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1742363354380,
    'updatedAt': 1742493703914,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'esES',
      },
      {
        'name': 'clonedFromForm',
        'value': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4732591,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742493703914,
    'businessUnitId': 0,
    'portableKey': '18f66bbb-aa9b-417c-9b26-ddd6d849befd',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //ENGLISH MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
    'name': 'Main Demo Form - English (EN)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Submit',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'First name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Last name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Phone number',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Email Address',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Company Website',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Number of contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1K',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 3K',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 25K',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 100K',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 500K',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M+',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 5K',
                'value': '0 - 5K',
                'displayOrder': 7,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 25K',
                'value': '5K - 25K',
                'displayOrder': 8,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 125K',
                'value': '25K - 125K',
                'displayOrder': 9,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '125K - 625K',
                'value': '125K - 625K',
                'displayOrder': 10,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '625K - 3M',
                'value': '625K - 3M',
                'displayOrder': 11,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3M+',
                'value': '3M+',
                'displayOrder': 12,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 500',
                'value': '0 - 500',
                'displayOrder': 13,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500 - 3K',
                'value': '500 - 3K',
                'displayOrder': 14,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 10K',
                'value': '3K - 10K',
                'displayOrder': 15,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '10K - 50K',
                'value': '10K - 50K',
                'displayOrder': 16,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K - 100K',
                'value': '50K - 100K',
                'displayOrder': 17,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 250K',
                'value': '100K - 250K',
                'displayOrder': 18,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '250K - 500K',
                'value': '250K - 500K',
                'displayOrder': 19,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M - 5M',
                'value': '1M - 5M',
                'displayOrder': 20,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5M+',
                'value': '5M+',
                'displayOrder': 21,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 5K',
                'value': '1K - 5K',
                'displayOrder': 22,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 3K',
                'value': '1 - 3K',
                'displayOrder': 23,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 5K',
                'value': '1 - 5K',
                'displayOrder': 24,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 5K',
                'value': '3K - 5K',
                'displayOrder': 25,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 50K',
                'value': '25K - 50K',
                'displayOrder': 26,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 200K',
                'value': '100K - 200K',
                'displayOrder': 27,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K - 300K',
                'value': '200K - 300K',
                'displayOrder': 28,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K - 400K',
                'value': '300K - 400K',
                'displayOrder': 29,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K - 500K',
                'value': '400K - 500K',
                'displayOrder': 30,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 750K',
                'value': '500K - 750K',
                'displayOrder': 31,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K - 1M',
                'value': '750K - 1M',
                'displayOrder': 32,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0-1K',
                'value': '0-1K',
                'displayOrder': 33,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K-3K',
                'value': '1K-3K',
                'displayOrder': 34,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K-5K',
                'value': '3K-5K',
                'displayOrder': 35,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-25K',
                'value': '5K-25K',
                'displayOrder': 36,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K-50K',
                'value': '25K-50K',
                'displayOrder': 37,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K-100K',
                'value': '50K-100K',
                'displayOrder': 38,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-200K',
                'value': '100K-200K',
                'displayOrder': 39,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K-300K',
                'value': '200K-300K',
                'displayOrder': 40,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K-400K',
                'value': '300K-400K',
                'displayOrder': 41,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K-500K',
                'value': '400K-500K',
                'displayOrder': 42,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K-750K',
                'value': '500K-750K',
                'displayOrder': 43,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K-1M',
                'value': '750K-1M',
                'displayOrder': 44,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Just starting out',
                'value': 'Just starting out',
                'displayOrder': 45,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'unknown',
                'value': 'unknown',
                'displayOrder': 46,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-500K',
                'value': '100K-500K',
                'displayOrder': 47,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-11K',
                'value': '5K-11K',
                'displayOrder': 48,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K-25K',
                'value': '11K-25K',
                'displayOrder': 49,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3 - 5K',
                'value': '3 - 5K',
                'displayOrder': 50,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5 - 25K',
                'value': '5 - 25K',
                'displayOrder': 51,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1-3K',
                'value': '1-3K',
                'displayOrder': 52,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3-5K',
                'value': '3-5K',
                'displayOrder': 53,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K+',
                'value': '400K+',
                'displayOrder': 54,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K - 25K',
                'value': '11K - 25K',
                'displayOrder': 55,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 11K',
                'value': '5K - 11K',
                'displayOrder': 56,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Tell me more. Sign me up for marketing communications from Klaviyo',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741762505703,
    'updatedAt': 1742487375816,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'lang',
        'value': 'en',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 0,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742974440676,
    'businessUnitId': 0,
    'portableKey': 'ae1fb3b3-6ce0-44ad-b9db-1cc1b2f80381',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //GERMAN MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': '348a481d-152a-4706-bc8a-740640429210',
    'name': 'Main Demo Form - German (DE)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Senden',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Vorname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nachname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-Mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Telefonnummer',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Website des Unternehmens',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Anzahl der Kontakte',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0-1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000-3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000-25.000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25.000-100.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000–500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000–1&nbsp;Mio.',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '+1&nbsp;Mio.',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 5K',
                'value': '0 - 5K',
                'displayOrder': 7,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 25K',
                'value': '5K - 25K',
                'displayOrder': 8,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 125K',
                'value': '25K - 125K',
                'displayOrder': 9,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '125K - 625K',
                'value': '125K - 625K',
                'displayOrder': 10,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '625K - 3M',
                'value': '625K - 3M',
                'displayOrder': 11,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3M+',
                'value': '3M+',
                'displayOrder': 12,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 500',
                'value': '0 - 500',
                'displayOrder': 13,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500 - 3K',
                'value': '500 - 3K',
                'displayOrder': 14,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 10K',
                'value': '3K - 10K',
                'displayOrder': 15,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '10K - 50K',
                'value': '10K - 50K',
                'displayOrder': 16,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K - 100K',
                'value': '50K - 100K',
                'displayOrder': 17,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 250K',
                'value': '100K - 250K',
                'displayOrder': 18,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '250K - 500K',
                'value': '250K - 500K',
                'displayOrder': 19,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M - 5M',
                'value': '1M - 5M',
                'displayOrder': 20,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5M+',
                'value': '5M+',
                'displayOrder': 21,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 5K',
                'value': '1K - 5K',
                'displayOrder': 22,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 3K',
                'value': '1 - 3K',
                'displayOrder': 23,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 5K',
                'value': '1 - 5K',
                'displayOrder': 24,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 5K',
                'value': '3K - 5K',
                'displayOrder': 25,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 50K',
                'value': '25K - 50K',
                'displayOrder': 26,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 200K',
                'value': '100K - 200K',
                'displayOrder': 27,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K - 300K',
                'value': '200K - 300K',
                'displayOrder': 28,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K - 400K',
                'value': '300K - 400K',
                'displayOrder': 29,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K - 500K',
                'value': '400K - 500K',
                'displayOrder': 30,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 750K',
                'value': '500K - 750K',
                'displayOrder': 31,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K - 1M',
                'value': '750K - 1M',
                'displayOrder': 32,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0-1K',
                'value': '0-1K',
                'displayOrder': 33,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K-3K',
                'value': '1K-3K',
                'displayOrder': 34,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K-5K',
                'value': '3K-5K',
                'displayOrder': 35,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-25K',
                'value': '5K-25K',
                'displayOrder': 36,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K-50K',
                'value': '25K-50K',
                'displayOrder': 37,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K-100K',
                'value': '50K-100K',
                'displayOrder': 38,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-200K',
                'value': '100K-200K',
                'displayOrder': 39,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K-300K',
                'value': '200K-300K',
                'displayOrder': 40,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K-400K',
                'value': '300K-400K',
                'displayOrder': 41,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K-500K',
                'value': '400K-500K',
                'displayOrder': 42,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K-750K',
                'value': '500K-750K',
                'displayOrder': 43,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K-1M',
                'value': '750K-1M',
                'displayOrder': 44,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Just starting out',
                'value': 'Just starting out',
                'displayOrder': 45,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'unknown',
                'value': 'unknown',
                'displayOrder': 46,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-500K',
                'value': '100K-500K',
                'displayOrder': 47,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-11K',
                'value': '5K-11K',
                'displayOrder': 48,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K-25K',
                'value': '11K-25K',
                'displayOrder': 49,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3 - 5K',
                'value': '3 - 5K',
                'displayOrder': 50,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5 - 25K',
                'value': '5 - 25K',
                'displayOrder': 51,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1-3K',
                'value': '1-3K',
                'displayOrder': 52,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3-5K',
                'value': '3-5K',
                'displayOrder': 53,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K+',
                'value': '400K+',
                'displayOrder': 54,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K - 25K',
                'value': '11K - 25K',
                'displayOrder': 55,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 11K',
                'value': '5K - 11K',
                'displayOrder': 56,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Ich würde gern mehr erfahren und möchte Marketing-Nachrichten von Klaviyo erhalten.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM-Quelle',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM-Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM-Kampagne',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM-Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM-Keyword',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741763133798,
    'updatedAt': 1742487009037,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'de',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 0,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742974440671,
    'businessUnitId': 0,
    'portableKey': '00510673-1a0c-4738-94fc-a99fc5760593',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //ITALIAN MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': 'b61a099c-bee0-430e-8de5-faedc1b832ef',
    'name': 'Main Demo Form - Italian (IT)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Invia',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Cognome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numero di telefono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sito web dell\'azienda',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Numero di contatti',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000 - 3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000 - 25.000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25.000 - 100.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000 - 500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000 - 1.000.000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Oltre 1.000.000',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 5K',
                'value': '0 - 5K',
                'displayOrder': 7,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 25K',
                'value': '5K - 25K',
                'displayOrder': 8,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 125K',
                'value': '25K - 125K',
                'displayOrder': 9,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '125K - 625K',
                'value': '125K - 625K',
                'displayOrder': 10,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '625K - 3M',
                'value': '625K - 3M',
                'displayOrder': 11,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3M+',
                'value': '3M+',
                'displayOrder': 12,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 500',
                'value': '0 - 500',
                'displayOrder': 13,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500 - 3K',
                'value': '500 - 3K',
                'displayOrder': 14,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 10K',
                'value': '3K - 10K',
                'displayOrder': 15,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '10K - 50K',
                'value': '10K - 50K',
                'displayOrder': 16,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K - 100K',
                'value': '50K - 100K',
                'displayOrder': 17,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 250K',
                'value': '100K - 250K',
                'displayOrder': 18,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '250K - 500K',
                'value': '250K - 500K',
                'displayOrder': 19,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M - 5M',
                'value': '1M - 5M',
                'displayOrder': 20,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5M+',
                'value': '5M+',
                'displayOrder': 21,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 5K',
                'value': '1K - 5K',
                'displayOrder': 22,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 3K',
                'value': '1 - 3K',
                'displayOrder': 23,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 5K',
                'value': '1 - 5K',
                'displayOrder': 24,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 5K',
                'value': '3K - 5K',
                'displayOrder': 25,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 50K',
                'value': '25K - 50K',
                'displayOrder': 26,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 200K',
                'value': '100K - 200K',
                'displayOrder': 27,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K - 300K',
                'value': '200K - 300K',
                'displayOrder': 28,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K - 400K',
                'value': '300K - 400K',
                'displayOrder': 29,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K - 500K',
                'value': '400K - 500K',
                'displayOrder': 30,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 750K',
                'value': '500K - 750K',
                'displayOrder': 31,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K - 1M',
                'value': '750K - 1M',
                'displayOrder': 32,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0-1K',
                'value': '0-1K',
                'displayOrder': 33,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K-3K',
                'value': '1K-3K',
                'displayOrder': 34,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K-5K',
                'value': '3K-5K',
                'displayOrder': 35,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-25K',
                'value': '5K-25K',
                'displayOrder': 36,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K-50K',
                'value': '25K-50K',
                'displayOrder': 37,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K-100K',
                'value': '50K-100K',
                'displayOrder': 38,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-200K',
                'value': '100K-200K',
                'displayOrder': 39,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K-300K',
                'value': '200K-300K',
                'displayOrder': 40,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K-400K',
                'value': '300K-400K',
                'displayOrder': 41,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K-500K',
                'value': '400K-500K',
                'displayOrder': 42,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K-750K',
                'value': '500K-750K',
                'displayOrder': 43,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K-1M',
                'value': '750K-1M',
                'displayOrder': 44,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Just starting out',
                'value': 'Just starting out',
                'displayOrder': 45,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'unknown',
                'value': 'unknown',
                'displayOrder': 46,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-500K',
                'value': '100K-500K',
                'displayOrder': 47,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-11K',
                'value': '5K-11K',
                'displayOrder': 48,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K-25K',
                'value': '11K-25K',
                'displayOrder': 49,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3 - 5K',
                'value': '3 - 5K',
                'displayOrder': 50,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5 - 25K',
                'value': '5 - 25K',
                'displayOrder': 51,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1-3K',
                'value': '1-3K',
                'displayOrder': 52,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3-5K',
                'value': '3-5K',
                'displayOrder': 53,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K+',
                'value': '400K+',
                'displayOrder': 54,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K - 25K',
                'value': '11K - 25K',
                'displayOrder': 55,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 11K',
                'value': '5K - 11K',
                'displayOrder': 56,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Voglio saperne di più e iscrivermi alle comunicazioni di marketing di Klaviyo.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'Fonte UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'Mezzo UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'Contenuto UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'Campagna UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'Termine UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741763457107,
    'updatedAt': 1742486820111,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'it',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 0,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742974440682,
    'businessUnitId': 0,
    'portableKey': 'de48b592-2398-428a-9533-7036ba8b323d',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },  
  //FRENCH MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': 'c24f3125-e60b-47d4-a2bc-ab9c02f66d26',
    'name': 'Main Demo Form - French (FR)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Soumettre',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Prénom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Adresse e-mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numéro de téléphone',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Site web de l’entreprise',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Nombre de contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1&nbsp;000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1&nbsp;000 - 3&nbsp;000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3&nbsp;000 - 25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000 - 100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000 - 500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000 - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M et +',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 5K',
                'value': '0 - 5K',
                'displayOrder': 7,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 25K',
                'value': '5K - 25K',
                'displayOrder': 8,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 125K',
                'value': '25K - 125K',
                'displayOrder': 9,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '125K - 625K',
                'value': '125K - 625K',
                'displayOrder': 10,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '625K - 3M',
                'value': '625K - 3M',
                'displayOrder': 11,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3M+',
                'value': '3M+',
                'displayOrder': 12,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 500',
                'value': '0 - 500',
                'displayOrder': 13,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500 - 3K',
                'value': '500 - 3K',
                'displayOrder': 14,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 10K',
                'value': '3K - 10K',
                'displayOrder': 15,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '10K - 50K',
                'value': '10K - 50K',
                'displayOrder': 16,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K - 100K',
                'value': '50K - 100K',
                'displayOrder': 17,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 250K',
                'value': '100K - 250K',
                'displayOrder': 18,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '250K - 500K',
                'value': '250K - 500K',
                'displayOrder': 19,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M - 5M',
                'value': '1M - 5M',
                'displayOrder': 20,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5M+',
                'value': '5M+',
                'displayOrder': 21,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 5K',
                'value': '1K - 5K',
                'displayOrder': 22,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 3K',
                'value': '1 - 3K',
                'displayOrder': 23,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 5K',
                'value': '1 - 5K',
                'displayOrder': 24,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 5K',
                'value': '3K - 5K',
                'displayOrder': 25,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 50K',
                'value': '25K - 50K',
                'displayOrder': 26,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 200K',
                'value': '100K - 200K',
                'displayOrder': 27,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K - 300K',
                'value': '200K - 300K',
                'displayOrder': 28,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K - 400K',
                'value': '300K - 400K',
                'displayOrder': 29,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K - 500K',
                'value': '400K - 500K',
                'displayOrder': 30,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 750K',
                'value': '500K - 750K',
                'displayOrder': 31,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K - 1M',
                'value': '750K - 1M',
                'displayOrder': 32,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0-1K',
                'value': '0-1K',
                'displayOrder': 33,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K-3K',
                'value': '1K-3K',
                'displayOrder': 34,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K-5K',
                'value': '3K-5K',
                'displayOrder': 35,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-25K',
                'value': '5K-25K',
                'displayOrder': 36,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K-50K',
                'value': '25K-50K',
                'displayOrder': 37,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K-100K',
                'value': '50K-100K',
                'displayOrder': 38,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-200K',
                'value': '100K-200K',
                'displayOrder': 39,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K-300K',
                'value': '200K-300K',
                'displayOrder': 40,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K-400K',
                'value': '300K-400K',
                'displayOrder': 41,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K-500K',
                'value': '400K-500K',
                'displayOrder': 42,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K-750K',
                'value': '500K-750K',
                'displayOrder': 43,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K-1M',
                'value': '750K-1M',
                'displayOrder': 44,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Just starting out',
                'value': 'Just starting out',
                'displayOrder': 45,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'unknown',
                'value': 'unknown',
                'displayOrder': 46,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-500K',
                'value': '100K-500K',
                'displayOrder': 47,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-11K',
                'value': '5K-11K',
                'displayOrder': 48,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K-25K',
                'value': '11K-25K',
                'displayOrder': 49,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3 - 5K',
                'value': '3 - 5K',
                'displayOrder': 50,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5 - 25K',
                'value': '5 - 25K',
                'displayOrder': 51,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1-3K',
                'value': '1-3K',
                'displayOrder': 52,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3-5K',
                'value': '3-5K',
                'displayOrder': 53,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K+',
                'value': '400K+',
                'displayOrder': 54,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K - 25K',
                'value': '11K - 25K',
                'displayOrder': 55,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 11K',
                'value': '5K - 11K',
                'displayOrder': 56,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Je veux en savoir plus. Je souhaite m’inscrire pour recevoir des communications marketing de Klaviyo.*',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'Source UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'Support UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'Campagne UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'Contenu UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'Terme UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741762810323,
    'updatedAt': 1742487165052,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'fr',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 0,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742974440671,
    'businessUnitId': 0,
    'portableKey': '0560d507-1f43-420d-8d71-cded30ad7b29',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //SPANISH MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': '3c37745a-8e57-40a1-abeb-fb0cd4c4dd69',
    'name': 'Main Demo Form - Spanish (ES)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Enviar',
    'followUpId': '',
    'notifyRecipients': '76794025',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nombre',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Apellidos',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Correo electrónico',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Número de teléfono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sitio web de la empresa',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Número de contactos',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1000-3000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3000-25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000-100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000-500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000-1&nbsp;000&nbsp;000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Más de un millón',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 5K',
                'value': '0 - 5K',
                'displayOrder': 7,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 25K',
                'value': '5K - 25K',
                'displayOrder': 8,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 125K',
                'value': '25K - 125K',
                'displayOrder': 9,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '125K - 625K',
                'value': '125K - 625K',
                'displayOrder': 10,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '625K - 3M',
                'value': '625K - 3M',
                'displayOrder': 11,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3M+',
                'value': '3M+',
                'displayOrder': 12,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0 - 500',
                'value': '0 - 500',
                'displayOrder': 13,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500 - 3K',
                'value': '500 - 3K',
                'displayOrder': 14,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 10K',
                'value': '3K - 10K',
                'displayOrder': 15,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '10K - 50K',
                'value': '10K - 50K',
                'displayOrder': 16,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K - 100K',
                'value': '50K - 100K',
                'displayOrder': 17,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 250K',
                'value': '100K - 250K',
                'displayOrder': 18,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '250K - 500K',
                'value': '250K - 500K',
                'displayOrder': 19,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M - 5M',
                'value': '1M - 5M',
                'displayOrder': 20,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5M+',
                'value': '5M+',
                'displayOrder': 21,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 5K',
                'value': '1K - 5K',
                'displayOrder': 22,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 3K',
                'value': '1 - 3K',
                'displayOrder': 23,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1 - 5K',
                'value': '1 - 5K',
                'displayOrder': 24,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 5K',
                'value': '3K - 5K',
                'displayOrder': 25,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 50K',
                'value': '25K - 50K',
                'displayOrder': 26,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 200K',
                'value': '100K - 200K',
                'displayOrder': 27,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K - 300K',
                'value': '200K - 300K',
                'displayOrder': 28,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K - 400K',
                'value': '300K - 400K',
                'displayOrder': 29,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K - 500K',
                'value': '400K - 500K',
                'displayOrder': 30,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 750K',
                'value': '500K - 750K',
                'displayOrder': 31,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K - 1M',
                'value': '750K - 1M',
                'displayOrder': 32,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '0-1K',
                'value': '0-1K',
                'displayOrder': 33,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K-3K',
                'value': '1K-3K',
                'displayOrder': 34,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K-5K',
                'value': '3K-5K',
                'displayOrder': 35,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-25K',
                'value': '5K-25K',
                'displayOrder': 36,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K-50K',
                'value': '25K-50K',
                'displayOrder': 37,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '50K-100K',
                'value': '50K-100K',
                'displayOrder': 38,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-200K',
                'value': '100K-200K',
                'displayOrder': 39,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '200K-300K',
                'value': '200K-300K',
                'displayOrder': 40,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '300K-400K',
                'value': '300K-400K',
                'displayOrder': 41,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K-500K',
                'value': '400K-500K',
                'displayOrder': 42,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K-750K',
                'value': '500K-750K',
                'displayOrder': 43,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '750K-1M',
                'value': '750K-1M',
                'displayOrder': 44,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Just starting out',
                'value': 'Just starting out',
                'displayOrder': 45,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'unknown',
                'value': 'unknown',
                'displayOrder': 46,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K-500K',
                'value': '100K-500K',
                'displayOrder': 47,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K-11K',
                'value': '5K-11K',
                'displayOrder': 48,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K-25K',
                'value': '11K-25K',
                'displayOrder': 49,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3 - 5K',
                'value': '3 - 5K',
                'displayOrder': 50,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5 - 25K',
                'value': '5 - 25K',
                'displayOrder': 51,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1-3K',
                'value': '1-3K',
                'displayOrder': 52,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3-5K',
                'value': '3-5K',
                'displayOrder': 53,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '400K+',
                'value': '400K+',
                'displayOrder': 54,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '11K - 25K',
                'value': '11K - 25K',
                'displayOrder': 55,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '5K - 11K',
                'value': '5K - 11K',
                'displayOrder': 56,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'form_opt_in',
            'label': 'Quiero saber más y suscribirme a las comunicaciones de marketing de Klaviyo.',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'additional_details',
            'label': 'Additional Details',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_to_app_conversion_id',
            'label': 'Web to App Conversion ID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': -1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1742363495428,
    'updatedAt': 1742493414664,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': false,
    'metaData': [
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'esES',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 0,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': true,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1742974440676,
    'businessUnitId': 0,
    'portableKey': '63d964e1-cd36-4d68-85a8-fe6c5bb576c1',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
];
